/**
 * Hook que trae del motor las publicaciones del periodo con los filtros de red, perfil y
 * texto. Lo usan las pestañas Publicaciones y Análisis.
 */
import { useEffect, useMemo, useState } from 'react';
import { queryRepository } from './repoApi';
import { POST_METRICS, monthEnd } from './socialRepoUtils';

export const POST_DIMENSIONS = ['Post ID', 'Fecha Publicación', 'Red', 'Perfil', 'Tipo', 'Formato', 'Texto', 'Enlace', 'Imagen Drive'];
export const POSTS_LIMIT = 5000;

/**
 * @returns {{loading: boolean, error: string, rows: Array, truncated: boolean}}
 */
export default function usePeriodPosts(repo, selection, period, { term = '', dataVersion = 0 } = {}) {
    const [state, setState] = useState({ loading: true, error: '', rows: [], truncated: false });
    const profileNames = useMemo(
        () => Array.from(new Set(selection.profiles.map(key => key.split('|').slice(1).join('|')))),
        [selection.profiles]
    );

    useEffect(() => {
        let alive = true;
        setState(prev => ({ ...prev, loading: true, error: '' }));
        const filters = [{ column: 'Fecha Publicación', operator: 'between', value: [`${period.from}-01`, monthEnd(period.to)] }];
        if (selection.networks.length) filters.push({ column: 'Red', operator: 'in', value: selection.networks });
        if (profileNames.length) filters.push({ column: 'Perfil', operator: 'in', value: profileNames });
        if (term) filters.push({ column: 'Texto', operator: 'contains', value: term });
        queryRepository(repo, [{
            id: 'posts',
            dataset: 'posts',
            dimensions: POST_DIMENSIONS,
            metrics: Object.fromEntries(POST_METRICS.map(m => [m, 'sum'])),
            filters,
            order_by: [{ field: 'Fecha Publicación', dir: 'desc' }],
            limit: POSTS_LIMIT,
        }]).then((results) => {
            if (!alive) return;
            const result = results.posts;
            if (!result?.ok) throw new Error(result?.error || 'No se pudieron leer las publicaciones.');
            const rows = result.records.map(row => ({ ...row, Publicaciones: 1 }));
            setState({ loading: false, error: '', rows, truncated: result.rowCount > result.records.length });
        }).catch((err) => {
            if (alive) setState({ loading: false, error: err.message, rows: [], truncated: false });
        });
        return () => { alive = false; };
    }, [repo, period, selection.networks, profileNames, term, dataVersion]);

    return state;
}
